import React from "react";
import {
  _ScrollProgressBarFill,
  _ScrollProgressBarRoot,
  _ScrollProgressBarTrack,
} from "./ScrollProgressBar.styled";

interface IScrollProgressBarProps {
  progress: number;
  hidden?: boolean;
  className?: string;
}

/** Discrete dot-style scroll progress for LandingInnovation ambiance-visual carousel (mobile). */
const ScrollProgressBar = (props: IScrollProgressBarProps) => {
  const { progress, hidden = false, className } = props;
  return (
    <_ScrollProgressBarRoot $hidden={hidden} className={className}>
      <_ScrollProgressBarTrack>
        <_ScrollProgressBarFill $progress={progress} />
      </_ScrollProgressBarTrack>
    </_ScrollProgressBarRoot>
  );
};

export default ScrollProgressBar;
